<section>
  <div class="py-20 px-6 mx-auto">
    <div class="text-center">
      <i class="pi pi-check-circle logout-icon"></i>
      <h1 class="logout-title">Signed Out</h1>
      <p class="logout-message">You have been securely signed out.</p>
      <p-button routerLink="/" label="Return to Login"></p-button>
    </div>
  </div>
</section>
